<template>
  <div class="more-features-container">
    <!-- 悬浮按钮 - 右下角 -->
    <div class="mf-fab" @click="togglePanel" title="更多功能">
      <div v-if="!open" class="mf-fab-inner">
        <div ref="lottieContainer" class="mf-fab-lottie"></div>
        <span class="mf-fab-label">更多功能</span>
      </div>
      <i v-else class="el-icon-close" style="font-size:28px;color:#764ba2"></i>
    </div>

    <!-- 弹窗 -->
    <transition name="mf-slide">
      <div v-if="open" class="mf-window"
           :class="{ maximized: isMaximized, dragging: isDragging, resizing: isResizing }"
           :style="windowStyle">

        <div class="mf-header" @mousedown="startDrag" @dblclick="toggleMaximize">
          <span><i class="el-icon-menu"></i> 更多功能</span>
          <div class="mf-header-actions">
            <div class="mf-maximize-btn" @click.stop="toggleMaximize" :title="isMaximized ? '还原' : '最大化'">
              <svg v-if="!isMaximized" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 5V1H5M9 1H13V5M13 9V13H9M5 13H1V9" stroke="#9d1bd1" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg v-else width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 1V5H1M13 5H9V1M9 13V9H13M1 9H5V13" stroke="#9d1bd1" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>

        <div class="mf-content">
          <div class="mf-apps-grid">
            <div
              v-for="app in apps"
              :key="app.key"
              class="mf-app-card"
              :class="{ loading: app.loading }"
              @click="jumpTo(app)">

              <!-- 图片区域 -->
              <div class="mf-card-img-wrap">
                <img :src="app.icon" :alt="app.name" class="mf-card-img" />
                <div class="mf-card-shine"></div>
              </div>

              <!-- 文字区域 -->
              <div class="mf-card-body">
                <div class="mf-app-name">{{ app.name }}</div>
                <div class="mf-app-desc">{{ app.desc }}</div>
                <div class="mf-card-arrow">进入 <i class="el-icon-arrow-right"></i></div>
              </div>

              <!-- 加载蒙层 -->
              <div v-if="app.loading" class="mf-app-loading">
                <i class="el-icon-loading"></i> 跳转中...
              </div>
            </div>
          </div>
        </div>

        <!-- 右下角缩放手柄 -->
        <div v-if="!isMaximized" class="mf-resize-handle" @mousedown="startResize" title="拖动调整大小"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import lottie from 'lottie-web'
import request from '@/utils/request'

export default {
  name: 'MoreFeatures',
  data() {
    return {
      open: false,
      winLeft: 0,
      winTop: 0,
      winWidth: 780,
      winHeight: 940,
      isMaximized: false,
      preMaxRect: null,
      isDragging: false,
      isResizing: false,
      dragStart: { x: 0, y: 0, left: 0, top: 0, width: 0, height: 0 },

      // 9个子系统配置
      apps: [
        { key: 'zfb',        icon: require('@/assets/imgs/xichong/企业信息筛查系统.png'),     name: '企业信息筛查系统',     desc: '法人信息智能筛查平台',   loading: false },
        { key: 'zh',         icon: require('@/assets/imgs/xichong/企业信息反查系统.png'),     name: '企业信息反查系统',     desc: '法人信息精准反查平台',   loading: false },
        { key: 'saas',       icon: require('@/assets/imgs/xichong/全球获客系统.jpg'),         name: '全球获客系统',         desc: '全球企业客户获取平台',   loading: false },
        { key: 'ghy',        icon: require('@/assets/imgs/xichong/高级企业信息筛查系统.png'), name: '高级企业信息筛查系统', desc: '股东信息高级智能筛查',   loading: false },
        { key: 'gzh',        icon: require('@/assets/imgs/xichong/高级企业信息反查系统.png'), name: '高级企业信息反查系统', desc: '股东信息高级精准反查',   loading: false },
        { key: 'tg',         icon: require('@/assets/imgs/xichong/推广系统.jpg'),             name: '推广系统',             desc: '推广佣金管理平台',       loading: false },
        { key: 'gsd',        icon: require('@/assets/imgs/xichong/号码归属地查询系统.png'),   name: '号码归属地查询系统',   desc: '手机号码归属地查询',     loading: false },
        { key: 'wj',         icon: require('@/assets/imgs/xichong/数海领航文件处理工具.png'), name: '数海领航文件处理工具', desc: '批量文件解析处理',       loading: false },
        { key: 'free-email', icon: require('@/assets/imgs/xichong/邮件群发系统.jpg'),         name: '邮箱群发系统',         desc: '批量邮件群发服务',       loading: false },
      ]
    }
  },
  mounted() {
    this.winLeft = Math.max(0, Math.round((window.innerWidth - this.winWidth) / 2))
    this.winTop  = Math.max(0, Math.round((window.innerHeight - this.winHeight) / 2))
    this.$nextTick(() => this.initLottie())
  },
  watch: {
    open(val) {
      if (!val) {
        this.$nextTick(() => this.initLottie())
      }
    }
  },
  methods: {
    initLottie() {
      if (!this.$refs.lottieContainer) return
      if (this._lottieAnim) { this._lottieAnim.destroy(); this._lottieAnim = null }
      import('@/assets/imgs/Machine Learning.json').then(animData => {
        if (!this.$refs.lottieContainer) return
        this._lottieAnim = lottie.loadAnimation({
          container: this.$refs.lottieContainer,
          renderer: 'svg', loop: true, autoplay: true,
          animationData: animData.default || animData
        })
      })
    },

    async jumpTo(app) {
      if (app.loading) return
      app.loading = true
      try {
        const res = await request({
          url: '/sso/token',
          method: 'get',
          params: { target: app.key }
        })
        if (res && res.code === '200' && res.data && res.data.ssoUrl) {
          window.open(res.data.ssoUrl, '_blank')
        } else {
          this.$message.error(res && res.msg ? res.msg : '跳转失败，请稍后重试')
        }
      } catch (e) {
        this.$message.error('跳转失败，请稍后重试')
      } finally {
        app.loading = false
      }
    },

    togglePanel() { this.open = !this.open },

    startDrag(e) {
      if (e.target.closest('.mf-header-actions') || e.target.closest('button')) return
      if (this.isMaximized) return
      this.isDragging = true
      this.dragStart = { x: e.clientX, y: e.clientY, left: this.winLeft, top: this.winTop }
      e.preventDefault()
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.endDrag)
    },
    onDrag(e) {
      if (!this.isDragging) return
      const dx = e.clientX - this.dragStart.x
      const dy = e.clientY - this.dragStart.y
      this.winLeft = Math.max(-(this.winWidth - 100), Math.min(this.dragStart.left + dx, window.innerWidth - 100))
      this.winTop  = Math.max(0, Math.min(this.dragStart.top + dy, window.innerHeight - 60))
    },
    endDrag() {
      this.isDragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.endDrag)
    },

    startResize(e) {
      if (this.isMaximized) return
      this.isResizing = true
      this.dragStart = { x: e.clientX, y: e.clientY, width: this.winWidth, height: this.winHeight }
      e.preventDefault(); e.stopPropagation()
      document.addEventListener('mousemove', this.onResize)
      document.addEventListener('mouseup', this.endResize)
    },
    onResize(e) {
      if (!this.isResizing) return
      this.winWidth  = Math.max(600, Math.min(this.dragStart.width  + (e.clientX - this.dragStart.x), window.innerWidth - 20))
      this.winHeight = Math.max(400, Math.min(this.dragStart.height + (e.clientY - this.dragStart.y), window.innerHeight - 20))
    },
    endResize() {
      this.isResizing = false
      document.removeEventListener('mousemove', this.onResize)
      document.removeEventListener('mouseup', this.endResize)
    },

    toggleMaximize() {
      if (this.isMaximized) {
        if (this.preMaxRect) {
          this.winLeft = this.preMaxRect.left; this.winTop = this.preMaxRect.top
          this.winWidth = this.preMaxRect.width; this.winHeight = this.preMaxRect.height
        }
        this.isMaximized = false
      } else {
        this.preMaxRect = { left: this.winLeft, top: this.winTop, width: this.winWidth, height: this.winHeight }
        this.winLeft = 0; this.winTop = 0
        this.winWidth = window.innerWidth; this.winHeight = window.innerHeight
        this.isMaximized = true
      }
    }
  },
  computed: {
    windowStyle() {
      return { left: this.winLeft + 'px', top: this.winTop + 'px', width: this.winWidth + 'px', height: this.winHeight + 'px' }
    }
  }
}
</script>

<style scoped>
/* ===== 悬浮按钮 ===== */
.mf-fab {
  position: fixed; right: 5px; bottom: 20px;
  width: 200px; height: 230px;
  background: transparent; border: none;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; z-index: 9999;
  transition: transform 0.3s;
}
.mf-fab:hover { transform: scale(1.08); }
.mf-fab-inner { display: flex; flex-direction: column; align-items: center; gap: 4px; }
.mf-fab-lottie { width: 200px; height: 200px; pointer-events: none; }
.mf-fab-label {
  font-family: 'XiangCuiJiXueSong' !important;
  font-size: 26px; letter-spacing: 4px; pointer-events: none;
}
@font-face {
  font-family: 'XiangCuiJiXueSong';
  src: url('@/assets/XIANGCUIJIXUESONG.ttf') format('truetype');
  font-weight: normal; font-style: normal;
}

/* ===== 弹窗 ===== */
.mf-window {
  position: fixed;
  background: linear-gradient(160deg, #f5f7ff 0%, #eef1fb 50%, #e8ecf8 100%);
  border-radius: 20px;
  box-shadow:
    0 32px 80px rgba(102,126,234,0.18),
    0 8px 24px rgba(0,0,0,0.08),
    inset 0 1px 0 rgba(255,255,255,0.95);
  border: 1px solid rgba(102,126,234,0.15);
  display: flex; flex-direction: column;
  z-index: 9998; overflow: hidden;
  user-select: none; -webkit-user-select: none;
  will-change: left, top, width, height;
}
.mf-window.dragging, .mf-window.resizing { cursor: grabbing; }
.mf-window.maximized {
  border-radius: 0; border: none;
  width: 100vw !important; height: 100vh !important;
  left: 0 !important; top: 0 !important;
}

/* ===== 标题栏 ===== */
.mf-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-bottom: none;
  color: #fff;
  padding: 14px 20px;
  font-size: 15px; font-weight: 600;
  letter-spacing: 1px;
  display: flex; justify-content: space-between; align-items: center;
  flex-shrink: 0; cursor: move;
}
.mf-header i { margin-right: 8px; font-size: 16px; opacity: 0.9; }
.mf-header-actions { display: flex; align-items: center; gap: 4px; cursor: default; }

.mf-maximize-btn {
  width: 28px;
  height: 28px;
  background: rgba(255,255,255,0.92);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
  flex-shrink: 0;
}
.mf-maximize-btn:hover { background: #fff; }
.mf-maximize-btn svg { display: block; }

/* ===== 内容区 ===== */
.mf-content {
  flex: 1; overflow-y: auto;
  padding: 14px 16px;
  background: transparent;
}
.mf-content::-webkit-scrollbar { width: 5px; }
.mf-content::-webkit-scrollbar-thumb { background: rgba(102,126,234,0.25); border-radius: 3px; }

/* ===== 应用网格 ===== */
.mf-apps-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

/* ===== 卡片 ===== */
.mf-app-card {
  background: #fff;
  border: 1px solid rgba(102,126,234,0.15);
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.34, 1.4, 0.64, 1);
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: 0 2px 12px rgba(102,126,234,0.08);
}
.mf-app-card:hover {
  transform: translateY(-6px);
  border-color: rgba(102,126,234,0.45);
  box-shadow:
    0 16px 40px rgba(102,126,234,0.18),
    0 0 0 1px rgba(102,126,234,0.2);
  background: #fff;
}
.mf-app-card:active { transform: translateY(-2px); }
.mf-app-card.loading { opacity: 0.6; cursor: not-allowed; }

/* ===== 图片容器 ===== */
.mf-card-img-wrap {
  width: 100%;
  height: 210px;
  position: relative;
  overflow: hidden;
  background: #f0f4ff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mf-card-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  display: block;
  transition: transform 0.4s ease;
}
.mf-app-card:hover .mf-card-img {
  transform: scale(1.03);
}

/* 图片右上角光泽 */
.mf-card-shine {
  position: absolute;
  top: 0; right: 0;
  width: 60%; height: 40%;
  background: radial-gradient(ellipse at top right, rgba(255,255,255,0.12) 0%, transparent 70%);
  pointer-events: none;
}

/* ===== 文字区域 ===== */
.mf-card-body {
  padding: 6px 10px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  background: #fff;
  border-top: 1px solid rgba(102,126,234,0.08);
  text-align: center;
}
.mf-app-name {
  font-size: 13px;
  font-weight: 700;
  color: #2d3a6b;
  line-height: 1.3;
  letter-spacing: 0.3px;
  text-align: center;
}
.mf-app-desc {
  font-size: 11px;
  color: #8a94b8;
  line-height: 1.2;
  text-align: center;
}
.mf-card-arrow {
  font-size: 11px;
  color: #667eea;
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  font-weight: 600;
  opacity: 0;
  transform: translateX(-4px);
  transition: all 0.25s ease;
}
.mf-app-card:hover .mf-card-arrow {
  opacity: 1;
  transform: translateX(0);
}

/* ===== 加载蒙层 ===== */
.mf-app-loading {
  position: absolute; inset: 0;
  background: rgba(255,255,255,0.8);
  backdrop-filter: blur(4px);
  display: flex; align-items: center; justify-content: center;
  font-size: 13px; color: #667eea; font-weight: 600;
  border-radius: 16px;
}

/* ===== 缩放手柄 ===== */
.mf-resize-handle {
  position: absolute; right: 0; bottom: 0;
  width: 20px; height: 20px; cursor: nwse-resize;
  background: linear-gradient(135deg,
    transparent 0%, transparent 40%,
    rgba(102,126,234,0.5) 40%, rgba(102,126,234,0.5) 55%,
    transparent 55%, transparent 70%,
    rgba(102,126,234,0.5) 70%, rgba(102,126,234,0.5) 85%,
    transparent 85%
  );
  transition: background 0.2s; z-index: 10;
}
.mf-resize-handle:hover {
  background: linear-gradient(135deg,
    transparent 0%, transparent 40%,
    rgba(102,126,234,0.9) 40%, rgba(102,126,234,0.9) 55%,
    transparent 55%, transparent 70%,
    rgba(102,126,234,0.9) 70%, rgba(102,126,234,0.9) 85%,
    transparent 85%
  );
}

/* ===== 动画 ===== */
.mf-slide-enter-active, .mf-slide-leave-active { transition: all 0.32s cubic-bezier(0.4, 0, 0.2, 1); }
.mf-slide-enter-from, .mf-slide-leave-to { opacity: 0; transform: translateY(28px) scale(0.93); }
</style>
